"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
function BalaoDeImagem(_a) {
  var _b = _a.tamanho,
    tamanho = _b === void 0 ? "medio" : _b,
    children = _a.children,
    props = __rest(_a, ["tamanho", "children"]);
  var sx = props.sx,
    rest = __rest(props, ["sx"]);
  var tamanhoDoBalao = function (tamanho) {
    switch (tamanho) {
      case "pequeno":
        return 28;
      case "grande":
        return 180;
      default:
        return 60;
    }
  };
  var tamanhoDoPadding = function (tamanho) {
    switch (tamanho) {
      case "pequeno":
        return "4px";
      case "grande":
        return "6px";
      default:
        return "10px";
    }
  };
  var tamanhoDoSVG = function (tamanho) {
    switch (tamanho) {
      case "pequeno":
        return "24px";
      case "grande":
        return "140px";
      default:
        return "48px";
    }
  };
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: __assign({
      borderRadius: "50%",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      height: tamanhoDoBalao(tamanho),
      width: tamanhoDoBalao(tamanho),
      background: "#fff",
      padding: tamanhoDoPadding(tamanho),
      boxShadow: "0px 6px 8px #0D0D361A",
      svg: {
        size: tamanhoDoSVG(tamanho)
      }
    }, sx)
  }, rest), children);
}
exports.default = BalaoDeImagem;